/**
 * ThreadListNotice — the in-list notice after an organization change
 * (2026-09-09): "moved to clients · undo". Polite, transient (the host's
 * timer), undo in place. Chrome copy only (D9).
 */
import React from 'react';
import { RailNotice, RailNoticeAction } from './organizeStyles';
import { threadListCopy } from './threadListCopy';
import type { ThreadListLang } from '../../types/threadCategories';
import type { ThreadListNoticeState } from './threadOrganize';

export interface ThreadListNoticeProps {
  notice: ThreadListNoticeState | null;
  lang: ThreadListLang;
  onDismiss: () => void;
}

export const ThreadListNotice: React.FC<ThreadListNoticeProps> = ({ notice, lang, onDismiss }) => {
  const copy = threadListCopy(lang);
  return (
    <div role="status" aria-live="polite" data-thread-list-notice-region="">
      {notice && (
        <RailNotice data-thread-list-notice={notice.id}>
          <span>{notice.text}</span>
          {notice.undo && (
            <RailNoticeAction type="button" data-thread-list-notice-undo="" onClick={() => { notice.undo?.(); onDismiss(); }}>
              {copy.undo}
            </RailNoticeAction>
          )}
        </RailNotice>
      )}
    </div>
  );
};

export default ThreadListNotice;
